<div
	#trigger
	(click)="openDropdown(trigger, schoolsMenu)"
	class="tw:bg-surface-grey tw:p-4 tw:rounded-lg tw:hidden tw:md:flex tw:items-center tw:gap-2 tw:cursor-pointer"
>
	<span
		class=""
		[ngClass]="{
			'tw:text-primary!': internalView(),
			'tw:text-purple!': !internalView(),
		}"
	>
		<mat-icon class="filled">villa</mat-icon>
	</span>
	<span class="tw:font-medium tw:text-base">{{ currentSchool.name | ellipsis: 35 }}</span>
	@if (hasMultipleSchools) {
		<mat-icon [hidden]="!isOpen">stat_1</mat-icon>
		<mat-icon [hidden]="isOpen">stat_minus_1</mat-icon>
	}
</div>
<ng-template #schoolsMenu>
	<div class="tw:bg-surface-primary tw:rounded-lg tw:shadow">
		<div class="tw:mb-4 tw:p-4 pb-0">
			<input
				class="tw:w-full tw:rounded-lg tw:px-4 tw:py-3 tw:border tw:border-[#DDDEDD] tw:bg-surface-primary tw:text-base tw:outline-purple"
				type="text"
				placeholder="Search"
				[formControl]="schoolSearch"
			/>
		</div>
		<div class="tw:flex tw:flex-col tw:gap-4 tw:max-h-[400px] tw:overflow-auto tw:p-4">
			@for (school of schools.filteredData; track school.id) {
				<div
					(click)="switchToSchool(school)"
					class="tw:p-1 tw:rounded tw:hover:bg-surface-grey tw:flex tw:gap-2 tw:cursor-pointer"
					[ngClass]="{ 'tw:bg-surface-grey': school.id === currentSchool.id }"
				>
					<mat-icon class="tw:text-surface-accent! filled">villa</mat-icon>
					<div class="tw:grow">
						<div class="tw:font-semibold tw:text-base tw:mb-1">{{ school.name }}</div>
						<div class="tw:text-secondary tw:font-medium tw:text-sm">{{ school.category }}</div>
					</div>
				</div>
			}
		</div>
	</div>
</ng-template>
